import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ExportedColDef } from '@/shared/models/ag-grid.model'
import { ColDef } from '@ag-grid-community/core'
import { Nullable } from '@/shared/types/app.types'
import { store } from '@/store/store'
import { StatisticalAnalysisSampleTagsStatisticsDossierBaseRequest, StatisticalAnalysisSampleTagsStatisticsDossierDetailExternalViewTable } from '@/modules/statistical-analysis-module/services/sample-tags-dossier/sample-tags-dossier.dto'
import { sampleTagsStatisticsDossierService } from '@/modules/statistical-analysis-module/services/sample-tags-dossier/sample-tags-dossier.service'
import { StatisticalAnalysisSampleTagsDossierExternalInfo } from '@/modules/statistical-analysis-module/views/labeled-samples-dossier/labeled-samples-dossier.model'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisExternalListTypes } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { getExternalColumnsEntity, getLabAndCaseId } from '@/modules/statistical-analysis-module/shared/helpers/helpers'
import { StatisticalAnalysisDatasourceExternalDetail } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-datasource'
import { InfinitePaginatorResponse } from '@/shared/resources/infinite-datasources/infinite-resource.model'
import { isNil } from 'lodash'
import { StatisticalAnalysisExternalListCase } from '@/modules/statistical-analysis-module/shared/external-list-columns/external-list-columns-cases'

export class StatisticalAnalysisHandlerDatasourcesSampleTagsDossierGeneralList extends StatisticalAnalysisDatasourceExternalDetail<StatisticalAnalysisExternalListTypes> {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisSampleTagsDossierExternalInfo>
    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisSampleTagsDossierExternalInfo>) {
        super()
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
    }

    public getGridColumns(): (ColDef | ExportedColDef)[] {
        return getExternalColumnsEntity(this.statisticalAnalysisFilters?.typeSearch?.id as StatiscalAnalysisTypeCases)
    }

    public async paginator(filterModel: CommonFilterModel, params: CommonParams, scrollId: string): Promise<InfinitePaginatorResponse<StatisticalAnalysisExternalListTypes>> {
        const sidebarFilter = this.statisticalAnalysisFilters as StatisticalAnalysisSampleTagsDossierExternalInfo
        const baseRequest: StatisticalAnalysisSampleTagsStatisticsDossierBaseRequest = sampleTagsStatisticsDossierService.getBaseRequest(sidebarFilter)
        const sampleTagId = sidebarFilter.trackingGeneralSelected?.key as number
        const response: StatisticalAnalysisSampleTagsStatisticsDossierDetailExternalViewTable = await sampleTagsStatisticsDossierService.getExternalViewGeneralList(filterModel, params, sampleTagId, baseRequest, scrollId, this.getTotalElements())
        if (isNil(this.getTotalElements())) {
            this.setTotalElements(response.scrollPage.totalElements)
        }
        return {
            content: response.content,
            scrollPage: {
                scrollId: encodeURIComponent(JSON.stringify(response.scrollPage.scrollId)),
                size: response.scrollPage.size,
                totalElements: response.scrollPage.totalElements
            }
        }
    }

    public getLabAndCaseId(selectedRow: StatisticalAnalysisExternalListTypes): [number, number] {
        const sidebarFilter = this.statisticalAnalysisFilters as StatisticalAnalysisSampleTagsDossierExternalInfo
        const typeCase = sidebarFilter?.typeSearch?.id as StatiscalAnalysisTypeCases
        return getLabAndCaseId(typeCase, selectedRow)
    }
}
